import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";

// SELECTORS
import { userData } from "../../../store/features/user/selectors";
import { currentLang } from "../../../store/features/translation/selectors";
import { languages } from "../../../store/features/translation/Languages";
import { selectedItineraryDay } from "../../../store/features/map/selectors";

// ACTIONS
import { setUserProfileId } from "../../../store/features/user/actions";
import { switchLang } from "../../../store/features/translation/actions";

// HELPERS
import { AuthService } from "../../../AuthService";
import { logEvent_ } from "../../../helpers/analytics";

// STYLES
import { whiteColor } from "../../../constants/colors";
import { gtag_report_conversion, types } from "../../../helpers/googleTags";

// ICONS
import IconOnBr from "../../../assets/img/wizard_open_ic.svg";
import MyTripsIcon from "../../../assets/svg/itinerary/mytrips_ic.svg";
import MyTripsLightIcon from "../../../assets/svg/itinerary/mytrips_light_ic.svg";

const Header = (props) => {
	// SELECTORS
	const currentUserData = useSelector(userData);
	const currentLanguage = useSelector(currentLang);
	const selectedTripItineraryDay = useSelector(selectedItineraryDay);
	// STATES
	const [showLanSwitch, setShowLanSwitch] = useState(null);
	const [lang] = useState(["EN", "GR", "FR"]); // to update

	const handleBack = () => {
		var newUrl = "https://" + window.location.host + "/explore/";
		window.history.pushState(null, null, newUrl);

		if (props.dispatch)
			props.dispatch({
				type: "closeslider",
				coordinates: props.mapCoordinates ? props.mapCoordinates : null,
			});
	};

	return (
		<div
			style={{
				zIndex: "999",
				position: "absolute",
				top: 0,
				width: "100%",
			}}
			className={
				props.page === "explore" || props.page === "home"
					? "header-home"
					: "header"
			}
		>
			<div style={{ fontSize: 25 }}>
				<Link
					onClick={() => {
						// EVENT
						logEvent_("react_auth_home_button_pressed");
					}}
					to="/"
					className="header-title"
					style={{
						cursor: "pointer",
						fontSize: 25,
						fontWeight: "600",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="93"
						height="20"
						viewBox="0 0 93 20"
					>
						<title style={{ backgroundColor: "transparent", border: "none" }}>
							keeano
						</title>
						<g fill="none" fillRule="evenodd">
							<g
								fill={props.page === "coastview" ? "white" : "#222C4B"}
								fillRule="nonzero"
							>
								<g>
									<path
										d="M70.392 4.62c-1.568-.032-3.059.683-4.015 1.926l-.077.1v-1.76h-2.473v14.78h2.57v-8.35c0-2.757 1.455-4.34 3.988-4.34 2.4 0 3.293 1.082 3.293 3.989v8.704h2.578v-8.704c0-2.067-.473-3.648-1.408-4.697-.974-1.093-2.47-1.647-4.456-1.647zM86.02 4.567c-4.276 0-6.933 2.956-6.933 7.714 0 4.758 2.657 7.713 6.932 7.713 4.276 0 6.936-2.955 6.936-7.713s-2.657-7.714-6.936-7.714zm0 13.019c-2.73 0-4.362-1.985-4.362-5.305 0-3.32 1.631-5.304 4.361-5.304 2.73 0 4.364 1.985 4.364 5.304 0 3.32-1.632 5.305-4.364 5.305zM7.393 11.495c.742-.563 1.421-1.202 2.028-1.907 1.15-1.364 2.08-2.898 2.756-4.55l.077-.178H9.482l-.035.074C8.32 7.247 6.827 8.968 5.01 10.049c-.727.44-1.52.76-2.35.945l-.052.01V0H0v19.658h2.608v-6.082h.038c.863-.122 1.698-.39 2.472-.79l.034-.016 4.886 6.893h3.16L7.36 11.519l.033-.024zM20.956 4.567c-2.193 0-4.03.742-5.31 2.147-1.258 1.374-1.922 3.321-1.922 5.622 0 2.259.658 4.169 1.901 5.526 1.28 1.394 3.123 2.138 5.33 2.138 3.032 0 5.406-1.496 6.526-4.106l-2.439-.849c-.086.176-.179.347-.235.458-.819 1.374-2.15 2.09-3.857 2.09-2.553 0-4.276-1.624-4.613-4.345v-.049h11.82v-.863c0-4.72-2.826-7.769-7.201-7.769zm-4.499 6.213l.013-.052c.48-2.348 2.159-3.751 4.486-3.751 2.29 0 3.952 1.403 4.456 3.751l.012.052h-8.967zM37.716 4.567c-2.195 0-4.031.742-5.313 2.147-1.256 1.374-1.919 3.321-1.919 5.622 0 2.259.657 4.169 1.9 5.526C33.664 19.256 35.506 20 37.716 20c3.022 0 5.394-1.489 6.517-4.088l-2.436-.844c-.085.176-.177.345-.227.44-.814 1.363-2.147 2.084-3.854 2.084-2.555 0-4.276-1.625-4.613-4.346v-.049h11.82v-.86c-.002-4.72-2.828-7.77-7.207-7.77zm-4.494 6.213l.01-.052c.485-2.348 2.163-3.751 4.484-3.751 2.29 0 3.95 1.403 4.457 3.751l.01.052h-8.961zM59.97 16.612v-6.456c0-1.799-.631-3.262-1.833-4.233-1.092-.887-2.63-1.356-4.443-1.356-2.947 0-4.974 1.927-5.813 3.578l-.061.119 2.22 1.041.058-.107c.232-.404.511-.78.83-1.12.743-.775 1.777-1.203 2.85-1.18 2.348 0 3.615 1.264 3.615 2.453v.18c-.062.816-2.256 1.187-4.086 1.356-1.895.18-3.391.672-4.445 1.463-1.14.86-1.72 1.968-1.72 3.294 0 2.65 1.914 4.3 4.996 4.3 2.525 0 4.275-.683 5.358-2.085l.049-.064.026.078c.378 1.159 1.423 1.797 2.94 1.797h.585v-2.415h-.61c-.477 0-.517-.49-.517-.643zm-2.57-4.244c0 1.782-.413 3.07-1.242 3.934-.829.864-2.052 1.278-3.747 1.278-1.585 0-2.693-.799-2.693-1.942 0-1.453 1.128-2.138 4.025-2.454 1.714-.18 2.89-.338 3.588-.85l.069-.051v.085z"
										transform="translate(-32.000000, -18.000000) translate(32.000000, 18.000000)"
									/>
								</g>
							</g>
						</g>
					</svg>
				</Link>
			</div>
			<div className="d-flex justify-content-center align-items-center">
				{props.page !== "home" && (
					<>
						{props.page === "explore" && (
							<Button
								onClick={() => {
									if (props.page === "explore") props.enableOnbroading();
								}}
								className="d-flex align-items-center mr-2"
								style={{
									fontFamily: "inherit",
									fontSize: 14,
									textTransform: "initial",
									color: props.page === "explore" ? "#222C4B" : "white",
									border: "none",
								}}
								// title={languages[currentLanguage]["user_trips_header"]}
							>
								<img src={IconOnBr} style={{ height: 20, width: 20 }} />
							</Button>
						)}

						<Button
							onClick={() => {
								props.setUserProfileId(null);
								props.showTripList();
							}}
							className="d-flex align-items-center mr-2 triplist-container-f"
							style={{
								fontFamily: "inherit",
								fontSize: 14,
								textTransform: "initial",
								color: props.page === "explore" ? "#222C4B" : "white",
								border: "none",
							}}
							title={languages[currentLanguage]["user_trips_header"]}
						>
							<img
								src={props.page === "explore" ? MyTripsIcon : MyTripsLightIcon}
								alt="MyTripsIcon"
								style={{ height: 20, objectFit: "contain" }}
							/>

							<span
								className="d-none d-sm-block ml-2"
								style={{ paddingTop: "2px" }}
							>
								{languages[currentLanguage]["user_trips_header"]}
							</span>
						</Button>

						{/*
						// ! Feature removed for the new business logic (don't ask me why)
						*/}
						{/* <Button
							onClick={() => {
								props.setUserProfileId(null);
								props.showTripItinerary();
							}}
							className="d-flex align-items-center mr-5 triplist-container-g"
							style={{
								fontFamily: "inherit",
								fontSize: 14,
								textTransform: "initial",
								color: props.page === "explore" ? "#222C4B" : "white",
								border: "none",
							}}
							title={languages[currentLanguage]["bar_nexttrip_hover"]}
						>
							<span style={{ position: "relative" }} className="mr-4">
								<div>
									<span className="d-flex justify-content-center align-items-center bookmark-tag">
										{selectedTripItineraryDay.tripNodes?.length +
											(selectedTripItineraryDay.launchPoint ? 1 : 0) +
											(selectedTripItineraryDay.shelterPoint ? 1 : 0)}
									</span>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17"
										height="20"
										viewBox="0 0 19 22"
									>
										<g fill="none" fillRule="evenodd" strokeLinejoin="round">
											<g
												stroke={
													props.page === "coastview" ? "white" : "#222C4B"
												}
												strokeWidth="2"
											>
												<g>
													<g>
														<path
															d="M0 0L16.783 0 16.783 20 8.391 12.974 0 20z"
															transform="translate(-1092.000000, -17.000000) translate(1081.000000, 12.000000) translate(12.000000, 6.000000)"
														/>
													</g>
												</g>
											</g>
										</g>
									</svg>
								</div>
							</span>
							<span className="d-none d-sm-block" style={{ paddingTop: "2px" }}>
								{languages[currentLanguage]["bar_nexttrip_button"]}
							</span>
						</Button> */}
					</>
				)}
				<div className="d-flex align-items-center">
					<span style={{ position: "relative" }} className="mr-2 select-lang">
						<Button
							onClick={() => setShowLanSwitch(!showLanSwitch)}
							style={{
								fontFamily: "inherit",
								fontSize: 14,
								color: props.page === "coastview" ? "white" : "#222C4B",
							}}
							title={languages[currentLanguage]["bar_language_hover_msg"]}
						>
							<span className="d-flex align-items-center">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
									viewBox="0 0 22 22"
									style={{ color: props.page === "explore" ? "#FFF" : "white" }}
								>
									<g fill="none" fillRule="evenodd">
										<title
											style={{ backgroundColor: "transparent", border: "none" }}
										>
											{languages[currentLanguage]["bar_language_hover_msg"]}
										</title>
										<g
											fill={props.page === "coastview" ? "white" : "#222C4B"}
											fillRule="nonzero"
											stroke={props.page === "coastview" ? "white" : "#222C4B"}
											strokeWidth=".5"
										>
											<g
												stroke={
													props.page === "coastview" ? "white" : "#222C4B"
												}
												fill={props.page === "coastview" ? "white" : "#222C4B"}
											>
												<path
													d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 19c-.792 0-1.812-1.475-2.436-4h4.872c-.624 2.525-1.644 4-2.436 4zm-2.65-5c-.191-1.035-.314-2.208-.34-3.5h5.98c-.026 1.292-.149 2.465-.34 3.5h-5.3zm-6.325-3.5H6.01c.025 1.24.136 2.42.325 3.5H1.95c-.532-1.065-.855-2.248-.925-3.5zM10 1c.792 0 1.812 1.475 2.436 4H7.564C8.188 2.475 9.208 1 10 1zm2.65 5c.191 1.035.314 2.208.34 3.5H7.01c.026-1.292.149-2.465.34-3.5h5.3zM6.01 9.5H1.025c.07-1.252.393-2.435.925-3.5h4.385c-.189 1.08-.3 2.26-.325 3.5zm7.98 1h4.985c-.07 1.252-.393 2.435-.925 3.5h-4.385c.189-1.08.3-2.26.325-3.5zm0-1c-.025-1.24-.136-2.42-.325-3.5h4.385c.532 1.065.855 2.248.925 3.5H13.99zM17.478 5h-4.017c-.37-1.592-.906-2.912-1.554-3.792 2.311.5 4.295 1.889 5.571 3.792zM8.093 1.208c-.648.88-1.185 2.2-1.554 3.792H2.522c1.276-1.903 3.26-3.291 5.57-3.792zM2.522 15h4.017c.37 1.592.906 2.912 1.554 3.792-2.311-.5-4.295-1.889-5.571-3.792zm9.385 3.792c.648-.88 1.185-2.2 1.554-3.792h4.017c-1.276 1.903-3.26 3.291-5.57 3.792z"
													transform="translate(-1273.000000, -17.000000) translate(1274.000000, 18.000000)"
												/>
											</g>
										</g>
									</g>
								</svg>
								<span
									className="ml-2"
									style={{
										color: props.page !== "coastview" ? "#222C4B" : "white",
										paddingTop: 4,
									}}
								>
									{currentLanguage}
								</span>
							</span>
						</Button>
					</span>
				</div>
				<button
					className={
						props.page === "home"
							? "d-none  profile-btn-i"
							: "d-block profile-btn-i"
					}
					onClick={() => {
						if (props.page === "explore") props.showAuth(currentUserData.ID);
						if (props.page === "coastview") handleBack();
					}}
					style={{
						border: "none",
						padding: 0,
						backgroundColor: "transparent",
					}}
				>
					{AuthService.isUserLogedIn() ? (
						<div
							style={{
								backgroundImage: `url(${currentUserData.Photo})`,
								backgroundColor: "#ddd",
								backgroundSize: "cover",
								backgroundPosition: "center",
								height: 32,
								width: 32,
								borderRadius: 5,
							}}
						/>
					) : (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="19"
							viewBox="0 0 23 22"
						>
							<g
								fill="none"
								fillRule="evenodd"
								strokeLinecap="round"
								strokeLinejoin="round"
							>
								<title
									style={{ backgroundColor: "transparent", border: "none" }}
								>
									{languages[currentLanguage]["bar_profile_hover_msg"]}
								</title>
								<g
									stroke={
										props.page === "explore" || props.page === "home"
											? "#222C4B"
											: "white"
									}
									strokeWidth="2"
								>
									<g>
										<g>
											<path
												d="M10.216 0c2.458 0 4.675 1.481 5.615 3.753.94 2.272.418 4.886-1.322 6.624-1.74 1.737-4.354 2.254-6.625 1.311-2.27-.943-3.748-3.162-3.745-5.62 0-1.611.64-3.156 1.78-4.294C7.06.636 8.605-.002 10.216 0h0zM0 19.974v-.3c0-2.918 2.366-5.284 5.284-5.284h9.687c2.919 0 5.284 2.366 5.284 5.284V20"
												transform="translate(-1343.000000, -17.000000) translate(1338.000000, 12.000000) translate(6.000000, 6.000000)"
											/>
										</g>
									</g>
								</g>
							</g>
						</svg>
					)}
				</button>
			</div>
			<div
				className={showLanSwitch ? "d-block" : "d-none"}
				style={{
					backgroundColor: whiteColor,
					position: "absolute",
					top: 65,
					right: 55,
					boxShadow: "0 0 4px gray",
					borderRadius: 5,
				}}
			>
				{lang.map((l, id) => (
					<button
						key={id}
						onClick={() => {
							props.switchLang(l);
							setShowLanSwitch(false);
						}}
						className="p-3 border-bottom"
						style={{
							border: "none",
							backgroundColor: "transparent",
						}}
					>
						{l}
					</button>
				))}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setUserProfileId: (userId) => dispatch(setUserProfileId(userId)),
		switchLang: (lang) => dispatch(switchLang(lang)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
